module.exports = __webpack_public_path__ + "static/media/d.e58d3df2.jpg";